import AbstractWorkFlowView from './AbstractWorkFlowView';
import RuleViewConstructorArgs from '../constructor/RuleViewConstructorArgs';
import NodeMouseEvent from '../support/NodeMouseEvent';
import * as d3 from 'd3';
import EventNodeView from '../node/EventNodeView';
import ActionNodeView from '../node/ActionNodeView';
import { Syntax } from '@trlogic/ui-pack';
import TransitionView from '../node/TransitionView';

class StandardWorkFlowView extends AbstractWorkFlowView {
  public constructor(args: RuleViewConstructorArgs) {
    super(args);
  }

  protected mouseMove(event: NodeMouseEvent): void {
    if (this.viewState.current) {
      this.viewState.current.renderPosition(event.position);
    }
    if (event.component && this.viewState.current && event.component.getNode() != this.viewState.current.getNode()) {
      this.viewState.target = event.component;
    } else {
      this.viewState.target = undefined;
    }
  }

  protected pointerClick(event: NodeMouseEvent): void {}

  public pointerDown(event: NodeMouseEvent): void {
    if (event.component) {
      this.viewState.current = event.component;
      this.highlightNodes(event.component.getModel().id);
      d3.select(event.component?.getNode()).style('pointer-events', 'none').style('position', 'absolute');
    }
  }

  protected pointerUp(event: NodeMouseEvent): void {
    if (this.viewState.current && (this.viewState.current.constructor == EventNodeView || this.viewState.current.constructor == ActionNodeView)) {
      this.unHighlightNodes((this.viewState.current as EventNodeView).getModel().id, event);
      this.viewState.current = undefined;
      return;
    }
    if (this.viewState.current && this.viewState.current?.isShadow()) {
      switch (this.viewState.current.constructor) {
        case ActionNodeView: {
          const index: number = this.actionViews.indexOf(this.viewState.current);
          if (index != -1) {
            const shadowView = this.actionViews.splice(index, 1)[0];
            shadowView.terminate();
            if (this.currentShadow) {
              this.getWorkflow().children?.[0].children?.forEach((e) => {
                e.children?.forEach((resolution) => {
                  this.removeLastChild(resolution);
                });
              });
            } else if (this.viewState.target instanceof TransitionView) {
              // TODO ARAYA EKLEME
              const targetSyntax = this.viewState.target.getModel();
              const currentSyntax = this.viewState.current.getModel();
              const targetParent = targetSyntax.parent;
              const targetChild = targetParent?.children?.shift();
              if (targetChild) {
                currentSyntax.parent = targetParent;
                currentSyntax.children = [targetSyntax];
                targetParent?.children?.push(currentSyntax);
                targetSyntax.parent = currentSyntax;
              }
            } else if (this.viewState.target && this.viewState.current && this.viewState.target.constructor == this.viewState.current.constructor) {
              this.viewState.current.swap(this.viewState.target);
            }
          }
          if (this.viewState.target && this.viewState.target.getModel().shadow) {
            const syntax = this.viewState.target.getModel();
            syntax.parent?.children?.push(syntax);
            syntax.shadow = false;
            this.addActionView(syntax, false);
          }
          this.viewState.current = undefined;
          this.reRender();
          break;
        }
      }
    }
  }

  private removeLastChild(e: Syntax): void {
    if (e.children && e.children.length != 0) {
      e.children?.forEach((e) => {
        this.removeLastChild(e);
      });
    } else if (e.children && e.children.length == 0) {
      const index = e.parent?.children?.indexOf(e);
      if (index != undefined && index != -1) {
        e.parent?.children?.splice(index, 1);
      }
    }
  }

  private handleComponentClick = (event: MouseEvent) => {
    const menuContainer: any = d3.select(this.el);
    if (menuContainer.node() && !menuContainer.node().contains(event.target)) {
      $(document).triggerHandler('workflow:closeresolution');
      document.removeEventListener('click', this.handleComponentClick);
    }
  };
}

export default StandardWorkFlowView;
